export default "__VITE_ASSET__DqKZvanl__"